module.exports = __webpack_public_path__ + "img/logo-login.80b6a220.png";